import React, { Component } from 'react'
import { CogWheel } from '../../icons/cogWheel'
import classnames from 'classnames'

import { UserBannerAvatar } from './userBannerComponents/userBannerAvatar'
import UserBannerTabs from './userBannerComponents/userBannerTabs'
import { UserBannerDropdown } from './userBannerComponents/userBannerDropdown'
import { User, Address } from '../../core/types'

export interface Props {
  user: User
  address?: Address
  wrapperClass?: string
  context: string
}

interface State {
  isDropdownActive: boolean
}

export class UserBanner extends Component<Props> {
  static displayName = 'UserHeader'

  state: State = {
    isDropdownActive: false,
  }

  toggleIsDropdownActive = () => {
    this.setState((state: State) => ({
      isDropdownActive: !state.isDropdownActive,
    }))
  }

  render() {
    const { isDropdownActive } = this.state
    const { user, address, context, wrapperClass } = this.props

    return (
      <div
        data-test="user-banner"
        className={classnames('user-banner', wrapperClass)}
      >
        <UserBannerAvatar user={user} context={context} />
        <UserBannerTabs user={user} address={address} />
        <UserBannerDropdown
          userId={user.id}
          isDropdownActive={isDropdownActive}
        />
        <button
          className="button__no-style user-banner__dropdown-toggle"
          onClick={this.toggleIsDropdownActive}
          data-testid="user-banner-dropdown-toggle"
        >
          {isDropdownActive ? <CogWheel color="#007aff" /> : <CogWheel />}
        </button>
      </div>
    )
  }
}
